export function formatInvoiceMoney(value, currency = 'USD') {
    const n = Number(value);
    if (!Number.isFinite(n)) return '—';
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(n);
}

export function invoiceStatusColor(status) {
    switch (status) {
        case 'draft':
            return 'default';
        case 'open':
            return 'info';
        case 'partial':
            return 'warning';
        case 'paid':
            return 'success';
        case 'void':
        case 'cancelled':
            return 'error';
        default:
            return 'default';
    }
}

export function emptyAddress() {
    return { line1: '', line2: '', city: '', region: '', postal: '', country: '' };
}

export function emptyLine() {
    return {
        product: '',
        product_name: '',
        description: '',
        quantity: '1',
        rate: '0',
        project_account: '',
    };
}

export function lineAmount(line) {
    const qty = Number(line.quantity);
    const rate = Number(line.rate);
    if (!Number.isFinite(qty) || !Number.isFinite(rate)) return 0;
    return Math.round(qty * rate * 100) / 100;
}
